import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { trackInternalEvent } from '@rio/tracking'

import { Container } from '../../components/Container'
import CategoryTabs from './components/CategoryTabs'
import { ProgressTracker } from './components/ProgressTracker'
import RecommendedJobs from './components/RecommendedJobs/RecommendedJobs'
import { CoachBanner } from './components/ResumeCoachBanner/CoachBanner'
import { ResumeWritingBanner } from './components/ResumeCoachBanner/ResumeWritingBanner'
import { DashboardContainer } from './components/ProgressTracker/styles'
import { Header } from './components/ProgressTracker/Header/Header'

/**
 * This is a temporary component to group all the new dashboard components
 * and features until we can refactor the entire dashboard.
 * It will probably be removed or refactored in the future.
 */

const DashboardV4 = () => {
  const [searchParams] = useSearchParams()
  const categoryTab = searchParams.get('categoryTab')

  useEffect(() => {
    if (categoryTab) {
      trackInternalEvent('visit_dashboard', { category: categoryTab })
    }
  }, [categoryTab])

  return (
    <Container>
      <CategoryTabs>
        <Header />
        <CategoryTabs.List>
          <CategoryTabs.Item tabId="resumes">Resume building</CategoryTabs.Item>
          <CategoryTabs.Item tabId="jobs">Job search</CategoryTabs.Item>
          <CategoryTabs.Item tabId="interview">Interview prep</CategoryTabs.Item>
          <CategoryTabs.Item tabId="learning">Learning</CategoryTabs.Item>
        </CategoryTabs.List>

        {/* Here will be the text that is rendered on mobile */}

        <DashboardContainer>
          <CategoryTabs.Content tabId="resumes">
            <ProgressTracker categoryId="resumes" />
          </CategoryTabs.Content>
          <CategoryTabs.Content tabId="jobs">
            <ProgressTracker categoryId="jobs" />
          </CategoryTabs.Content>
          <CategoryTabs.Content tabId="interview">
            <ProgressTracker categoryId="interview" />
          </CategoryTabs.Content>
          <CategoryTabs.Content tabId="learning">
            <ProgressTracker categoryId="learning" />
          </CategoryTabs.Content>

          <RecommendedJobs />

          <CategoryTabs.Content tabId="resumes">
            <ResumeWritingBanner />
          </CategoryTabs.Content>
          <CategoryTabs.Content tabId="jobs">
            <CoachBanner />
          </CategoryTabs.Content>
          <CategoryTabs.Content tabId="interview">
            <CoachBanner />
          </CategoryTabs.Content>
          <CategoryTabs.Content tabId="learning">
            <CoachBanner />
          </CategoryTabs.Content>
        </DashboardContainer>
      </CategoryTabs>
    </Container>
  )
}

export default DashboardV4
